import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../redux/actions/index';
import { Col, Row } from 'react-materialize';
import CompatabilityIndicator from './CompatabilityIndicator';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignal } from '@fortawesome/free-solid-svg-icons';
import TEST_STATUS from '../../constants/status';

class Connection extends Component {
	constructor(props) {
		super(props);

		this.state = {
			messages: {
				loading: 'Testing your internet connection...',
				pending: 'Test your internet connection',
				fail: 'Sorry, based on your computer, you are unable to participate in this study',
				success: 'Your internet is strong!',
			},
		};

		this.testConnection = this.testConnection.bind(this);
		this.testConnectivity = this.testConnectivity.bind(this);
		this.testConnectionSpeed = this.testConnectionSpeed.bind(this);
	}

	async simulateDownloadAndConnectionSpeed() {
		const imageURL = new URL(
			'images/download-image-tech-check.jpg',
			'https://pilotly-public.s3.amazonaws.com'
		);
		const downloadSize = 5470617; // this must match with the image above

		const startTime = new Date().getTime();
		// this query param is added to force a download without cache,
		// as it will always generate an unique URL
		imageURL.searchParams.set('timestamp', startTime);
		const download = new Image();
		download.src = imageURL.toString();
		// this returns when the image is finished downloading
		await download.decode();
		const endTime = new Date().getTime();
		const duration = (endTime - startTime) / 1000;
		const bitsLoaded = downloadSize * 8;
		const speedBps = (bitsLoaded / duration).toFixed(2);
		const speedKbps = (speedBps / 1024).toFixed(2);
		const speedMbps = (speedKbps / 1024).toFixed(2);
		return Math.round(Number(speedMbps));
	}

	testConnectivity() {
		// In Chrome and Safari, if the browser is not able to connect to a local area network (LAN) or a router, it is offline.
		// All other conditions return true.
		// So while we can assume that the browser is offline when it returns a false value,
		// we cannot assume that a true value necessarily means that the browser can access the internet.
		// That's why we need to check both the connectivity and the connection speed.
		const isUserOnline = navigator.onLine;
		const connectivityTest = isUserOnline
			? TEST_STATUS.success
			: TEST_STATUS.fail;
		this.props.setTechCheckConnectionResult(connectivityTest);
	}

	async testConnectionSpeed() {
		const expectedConnectionSpeed = 5; //mbps
		let connectionSpeed;

		if (navigator.connection && navigator.connection.downlink !== undefined) {
			// This is a recent native feature, so it lacks compatability
			// at the time of the development, it's only compatible with Chrome, Edge and Opera
			// https://caniuse.com/netinfo
			connectionSpeed = navigator.connection.downlink;
		}
		if (!navigator.connection || connectionSpeed < expectedConnectionSpeed) {
			// If navigator.connection.downlink expands the compatability to Safari and Firefox
			// this whole function should be refactored
			connectionSpeed = await this.simulateDownloadAndConnectionSpeed();
		}
		const speedTest =
			connectionSpeed >= expectedConnectionSpeed
				? TEST_STATUS.success
				: TEST_STATUS.fail;
		this.props.setTechCheckConnectionSpeedResult(speedTest);
	}

	async testConnection() {
		this.setState({ loading: true });
		this.testConnectivity();
		await this.testConnectionSpeed();
		if (
			this.props.connection === TEST_STATUS.fail ||
			this.props.connectionSpeed === TEST_STATUS.fail
		) {
			this.props.onFail('Internet');
		}
		this.setState({ loading: false });
	}

	render() {
		const { connection, connectionSpeed } = this.props;
		const status = [connection, connectionSpeed];
		let result, iconColor;

		if (this.state.loading) {
			result = TEST_STATUS.loading;
			iconColor = '#ffffff';
		} else if (status.some((result) => result === TEST_STATUS.fail)) {
			result = TEST_STATUS.fail;
			iconColor = '#ffa3a3';
		} else if (status.some((result) => result === TEST_STATUS.pending)) {
			result = TEST_STATUS.pending;
			iconColor = '#ffffff';
		} else if (status.every((result) => result === TEST_STATUS.success)) {
			result = TEST_STATUS.success;
			iconColor = '#64ffea';
		}

		return (
			<div>
				<div className="dp-instructions tech-check-test-title">
					Internet Connectivity
				</div>
				<Row>
					<Col s={12} m={6}>
						<FontAwesomeIcon icon={faSignal} size="3x" color={iconColor} />
					</Col>
					<Col s={12} m={6}>
						<CompatabilityIndicator
							state={result}
							messages={this.state.messages}
						/>
					</Col>
				</Row>
				<Row>
					<button disabled={this.state.loading} onClick={this.testConnection}>
						Test Connection
					</button>
				</Row>
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	connection: state.techCheck.connection,
	connectionSpeed: state.techCheck.connectionSpeed,
});

export default connect(mapStateToProps, actions)(Connection);



// WEBPACK FOOTER //
// ./src/components/tech-check/Connection.js